import { Component, OnInit } from "@angular/core";
import { Contact } from "../../entities/Contact";
import { ActivatedRoute } from "@angular/router";
import { NavController } from "@ionic/angular";
import { API_URL } from "../../../environments/environment";
import { AuthService } from "../../services/auth/auth.service";
import { ContactsService } from "../../services/contacts/contacts.service";
import { BrowserService } from "../../services/browser/browser.service";
import { Capacitor } from "@capacitor/core";

@Component({
    selector: "app-authors-page",
    templateUrl: "./authors.page.html",
    styleUrls: ["./authors.page.scss"]
})
export class AuthorsPage implements OnInit {
    public contact = new Contact(null);
    public isDataLoaded = false;
    public language =
        this.authService.authState.getValue().authUser?.language_code ?? "en";
    private readonly contactId;

    constructor(
        private authService: AuthService,
        private contactsService: ContactsService,
        private route: ActivatedRoute,
        private navController: NavController
    ) {
        this.contactId = parseInt(this.route.snapshot.params.authorId, 0);
    }

    ngOnInit() {
        this.contactsService.fetchContact(this.contactId).subscribe((data) => {
            this.contact = new Contact(data);
            this.isDataLoaded = true;
        });
    }

    goBack() {
        this.navController.pop();
    }

    call(phone?: string) {
        const number = phone ?? this.contact?.phone;
        if (!number) {
            return;
        }
        if (Capacitor.isNativePlatform()) {
            window.open(`tel:${number}`, "_system");
        } else {
            window.location.href = `tel:${number}`;
        }
    }

    mail(email?: string) {
        const address = email ?? this.contact?.email;
        if (!address) {
            return;
        }
        if (Capacitor.isNativePlatform()) {
            window.open(`mailto:${address}`, "_system");
        } else {
            window.location.href = `mailto:${address}`;
        }
    }

    loadContactSecureImage(contact) {
        if (!contact.photo) {
            return "../assets/images/default-account.png";
        }

        const token = this.authService.authState.getValue().token;

        return `${API_URL}/files/contacts/${contact.photo}?token=${token}`;
    }
}
